import { baseApi } from '@/features/api/baseApi';
import directus, { type DirectusErrorType } from '@/features/api/directus';
import type { HomePage, MenuFooter, MenuHeader } from '@/models/types';
import { readSingleton } from '@directus/sdk';

const layoutApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ['menu_header', 'menu_footer', 'home_page'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getMenuHeader: builder.query<MenuHeader, void>({
        queryFn: async () => {
          try {
            const data = await directus.request<MenuHeader>(readSingleton('MenuHeader'));
            return { data };
          } catch (error: unknown) {
            return { error: error as DirectusErrorType };
          }
        },
        providesTags: ['menu_header'],
        keepUnusedDataFor: 3600, // 1 hour
      }),
      getMenuFooter: builder.query<MenuFooter, void>({
        queryFn: async () => {
          try {
            const data = await directus.request<MenuFooter>(readSingleton('MenuFooter'));
            return { data };
          } catch (error: unknown) {
            return { error: error as DirectusErrorType };
          }
        },
        providesTags: ['menu_footer'],
        keepUnusedDataFor: 3600, // 1 hour
      }),
      getHomePage: builder.query<HomePage, void>({
        queryFn: async () => {
          try {
            const data = await directus.request<HomePage>(
              readSingleton('HomePage', {
                fields: [
                  '*',
                  {
                    banners: [
                      {
                        Banner_id: [
                          '*',
                          {
                            roles: [
                              {
                                Role_id: ['id', 'name'],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              }),
            );
            return { data };
          } catch (error: unknown) {
            return { error: error as DirectusErrorType };
          }
        },
        providesTags: ['home_page'],
        keepUnusedDataFor: 3600, // 1 hour
      }),
    }),
  });

export const { useGetMenuHeaderQuery, useGetMenuFooterQuery, useGetHomePageQuery } = layoutApi;
